import * as types from './actionTypes'

export const isLoading = payload => {
    return { type: types.EVENIMENTS_IS_LOADING, payload }
}

export const fetchError = payload => {
    return { type: types.EVENIMENTS_FETCH, payload }
}

export const fetchSuccess = payload => {
    let data = Object.values(payload.val())
    let keys = Object.keys(payload.val())

    data.map((item, idx) => {
        item.id = keys[idx]

        return null
    })

    return { type: types.EVENIMENTS_FETCH, payload: data }
}

export const addSuccess = payload => {
    return { type: types.EVENIMENTS_ADD, payload }
}

export const add = payload => {
    return (dispatch, getState, getFirebase) => {
        const firebase = getFirebase()

        firebase
            .push('eveniments', payload)
            .then(ref => {
                dispatch(addSuccess({ id: ref.key, ...payload }))
            })
    }
}

export const remove = id => {
    return (dispatch, getState, getFirebase) => {
        const firebase = getFirebase()

        firebase
            .ref(`eveniments/${id}`)
            .remove()
            .then(() => {
                dispatch(fetch())
            })
    }
}

export const fetch = () => {
    return (dispatch, getState, getFirebase) => {
        const firebase = getFirebase()

        firebase
            .ref('eveniments')
            .once('value')
            .catch(error => dispatch(fetchError(error)))
            .then(snapshot => {
                if(snapshot.val()) {
                    dispatch(fetchSuccess(snapshot))
                }
            })
    }
}


// WEBPACK FOOTER //
// ./src/store/actions/evenimentsActions.js